import http from "../http/http-config";

export default new class FilePathService {

    getFilePath(configRoot): Promise<string[]> {
        return http.get<string[]>("FilePath", {
            params: {
                configRoot
            }
        }).then(response => response.data);
    }

    validateUrl(url): Promise<boolean> {
        return http.get<boolean>("FilePath/ValidateUrl", {
            params: {
                url
            }
        }).then(response => response.data);
    }
}